function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import RegularButton from "segments/desktop/core-components/button/regular-button/regular-button";
import { CONTACT_US_FROM_HEADER_PAGE_LINK } from "constants/links";
import { CONTACT_SALES_BUTTON_CLICKED, CONTACT_SALES_SCROLL_TO_FORM_CLICKED } from "constants/bigbrain-event-types";
import { trackEvent } from "/services/bigbrain-service";
import { HUBSPOT_CONTACT_SALES_CTA, HUBSPOT_CONTACT_SALES_CTA_TRANSLATED } from "/client/services/hubspot-service/hubspot-constants";
import { getRawTranslationValue } from "/services/localization/localization-service";
import { withGenericConfig } from "contexts/generic-config-context";
import { addProductParamToContactSalesUrl } from "./contact-sales-url";
import DefaultProps from "./default-props";
import { isRunningInClient } from "services/dom-utils-service";
const ContactSalesButton = (props)=>{
    const { contactSalesTranslateKey, scrollToElementId, onClick, translate, contactSalesProductParam, baseUrl, headerCatalogLinks } = props, restProps = _object_without_properties(props, [
        "contactSalesTranslateKey",
        "scrollToElementId",
        "onClick",
        "translate",
        "contactSalesProductParam",
        "baseUrl",
        "headerCatalogLinks"
    ]);
    const resolveLocalizedUrl = (url)=>{
        const [basePath, queryString] = url.split("?");
        var _headerCatalogLinks_basePath;
        const localizedBase = (_headerCatalogLinks_basePath = headerCatalogLinks === null || headerCatalogLinks === void 0 ? void 0 : headerCatalogLinks[basePath]) !== null && _headerCatalogLinks_basePath !== void 0 ? _headerCatalogLinks_basePath : basePath;
        return queryString ? `${localizedBase}?${queryString}` : localizedBase;
    };
    const getButtonUrlConfig = ()=>{
        const elementExists = scrollToElementId && isRunningInClient() && document.getElementById(scrollToElementId);
        const contactUsBaseUrl = resolveLocalizedUrl(baseUrl || CONTACT_US_FROM_HEADER_PAGE_LINK);
        const url = elementExists ? `#${scrollToElementId}` : addProductParamToContactSalesUrl(contactUsBaseUrl, contactSalesProductParam);
        return {
            url,
            isScrolling: !!elementExists
        };
    };
    const translateKey = contactSalesTranslateKey || "header.contactSales";
    const buttonText = translate(translateKey);
    const { url, isScrolling } = getButtonUrlConfig();
    const handleContactSalesClick = (e)=>{
        var _localStorage, _localStorage1;
        const eventToTrack = isScrolling ? CONTACT_SALES_SCROLL_TO_FORM_CLICKED : CONTACT_SALES_BUTTON_CLICKED;
        trackEvent(eventToTrack, {
            info2: url,
            kind: buttonText
        });
        const englishText = getRawTranslationValue(translateKey);
        (_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.setItem(HUBSPOT_CONTACT_SALES_CTA, englishText);
        (_localStorage1 = localStorage) === null || _localStorage1 === void 0 ? void 0 : _localStorage1.setItem(HUBSPOT_CONTACT_SALES_CTA_TRANSLATED, buttonText);
        if (onClick) {
            onClick(e);
        }
    };
    return /*#__PURE__*/ _jsx(RegularButton, _object_spread_props(_object_spread({}, restProps), {
        buttonText: buttonText,
        url: url,
        onClick: handleContactSalesClick,
        disableBigBrainEvent: true
    }));
};
export default withGenericConfig(ContactSalesButton);
ContactSalesButton.defaultProps = DefaultProps;
